export default __webpack_public_path__ + "static/media/momwithbaby.a4a59f4b46680dcad48711175cedea9c.svg";